import React from 'react';
import { instanceOf, func } from 'prop-types';
import CTTableRowItems from './CTTableRowItems';

const CTTableRow = ({ data, handleOnRowSelect, handleAction }) => {
  return data.map(item => {
    return (
      <CTTableRowItems
        key={item.id}
        data={item}
        onRowSelect={handleOnRowSelect}
        handleAction={handleAction}
      />
    );
  });
};

CTTableRow.propTypes = {
  data: instanceOf(Object).isRequired,
  handleOnRowSelect: func,
  handleAction: func,
};

CTTableRow.defaultProps = {
  data: null,
};

export default CTTableRow;
